import React, { useState } from 'react';
import { ManagedUser } from '../../types';
import styles from './ConfirmDeleteModal.module.css';

interface ConfirmDeleteModalProps {
  user: ManagedUser;
  loading: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({ user, loading, onConfirm, onClose }) => {
  const [confirmText, setConfirmText] = useState('');

  const isConfirmed = confirmText.toLowerCase() === 'delete';

  return (
    <div className={styles.modalBackdrop}>
      <div className={`${styles.modalContent} card`}>
        <div className="card-body">
          <h5 className="card-title text-danger">Delete User</h5>
          <p>
            You are about to permanently delete{' '}
            <strong>{user.name || user.email}</strong>. This action cannot be undone.
          </p>
          <div className="mb-3">
            <label htmlFor="confirmDelete" className="form-label">
              Type <strong>delete</strong> to confirm
            </label>
            <input
              id="confirmDelete"
              type="text"
              className="form-control"
              placeholder="delete"
              value={confirmText}
              onChange={e => setConfirmText(e.target.value)}
              autoFocus
              disabled={loading}
            />
          </div>
          <div className="d-flex justify-content-end gap-2">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger"
              disabled={!isConfirmed || loading}
              onClick={onConfirm}
            >
              {loading ? 'Deleting...' : 'Delete User'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
